import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.5 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5","key":"svg-0"}]]

/**
 * IconVolume4
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdm9sdW1lLTQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTkuNSAxNWgtMmExIDEgMCAwIDEgLTEgLTF2LTRhMSAxIDAgMCAxIDEgLTFoMmwzLjUgLTQuNWEuOCAuOCAwIDAgMSAxLjUgLjV2MTRhLjggLjggMCAwIDEgLTEuNSAuNWwtMy41IC00LjUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/volume-4
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconVolume4 = createReactComponent('outline', 'volume-4', 'Volume4', __iconNode);

export default IconVolume4;